import { action } from "typesafe-actions";
import { IFrontendSettings, SettingActionTypes } from "./types";

export const fetchRequest = () => action(SettingActionTypes.FETCH_REQUEST);
export const fetchSuccess = (data: IFrontendSettings) => action(SettingActionTypes.FETCH_SUCCESS, data);
export const fetchError = (message: string) => action(SettingActionTypes.FETCH_ERROR, message);
